<template>
    <!-- Visualizing target audience as Personas  -->
    <section class="montserrat  mx-auto mt-10 md:mt-64">
  <div class="text-2xl md:text-3xl md:px-0 px-10 mb-10 md:mb-20 text-white">
    <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold ml-20 text-white">Visualizing target audience as Personas</h1>
  </div>
  <img loading="lazy" class="w-[80%] container ml-44" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659022/Group_34204_mcp4we.png" alt="Visualizing target audience">
    </section>
   
    <!-- Content Inventory -->
    <section class="container md:px-0 px-10 w-full mx-auto mt-10 md:mt-64">
  <div class="text-2xl md:text-3xl mb-6 md:mb-10 ml-22">
    <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white r-[2]">Process</h1>
    <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">Content Inventory</p>
  </div>
  
  <div class="flex text-xl flex-col md:flex-row gap-10 justify-between items-center pt-6 md:pt-10">
  <div class="w-full md:w-2/3">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659190/screen_rojrbi.png" alt="Content Inventory" class="w-full h-auto">
  </div>
  <div class="text-white w-full md:w-1/3 flex items-center">
    <p class="pt-6 text-lg md:pt-16">It was found that within the main categories, subcategories are further reduced down to sub-subcategories.</p>
  </div>
</div>

<div class="flex flex-col text-xl md:flex-row gap-10 justify-between items-center pt-10 md:pt-10">
  <div class="text-white w-full md:w-1/3 flex items-center">
    <p class="pt-6 text-lg md:pt-16">While all the content holds importance, the many topics clutter the drop-down menus when content can be combined.</p>
  </div>
  <div class="w-full md:w-2/3">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659230/screen22_voaxj6.png" alt="Content Clutter" class="w-full h-auto">
  </div>
</div>

    </section>
    <!-- Content Inventory conti -->
    <section class="w-full  flex flex-col justify-center items-center mt-20">
  <p class="text-white text-lg md:text-xl mt-4"> 
    Content Inventory helped to target repetitive menu items, allowing one to absorb another and combining content together.
  </p>
  
      
  <section
    v-if="isVisible"
    class="w-full flex background-lor flex-col items-center justify-center text-center   transition-transform duration-500 ease-in-out mt-8"
    :class="{'opacity-0 scale-0': !inView, 'opacity-100 scale-100': inView}"
    ref="popupSection"
  >
    <div class="text-white text-center text-sm md:text-4xl">
      <p class="dancing-script mb-1 md:mb-6">Reduced Categories <br>from</p>
      <p class="montserrat font-bold">123 &#8594; 62</p>
    </div>
  </section>

</section>
  <section class="mt-44 px-20 container mx-auto">
    <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">Card Sort</p>
    <p class="text-white text-3xl dancing-script pt-12">Open Pilot Card Sort </p>
  </section>

    <!-- section 4 -->
    <section class="w-full flex flex-col justify-center items-center mt-10 ">
  <section
    class="w-full container flex background-lor flex-col items-center justify-center text-center   transition-transform duration-500 ease-in-out"
  >
    <div class="text-white text-center text-sm md:text-4xl">
      <p class="dancing-script mb-1 md:mb-6">Results</p>
      <ul class=" flex justify-between gap-10 dancing-script md:text-4xl text-white">
        <li>Participants       <span class=" montserrat font-bold">:3</span></li>
        <li>Cards              <span class=" montserrat font-bold">:62</span></li>
        <li>Created Categories  <span class=" montserrat font-bold">:14</span></li>
      </ul>
    </div>
  </section>
</section>


    <!-- scetion 5 -->
    <section class=" md:mt-6 px-4 md:px-20 container md:mx-auto text-white text-xl md:text-3xl">
  <p class="pt-12 text-lg md:pt-16">
    Due to <span class="text-amber-100">overlapping cards</span>, the categories were further <span class="text-amber-100">reduced to 7:</span>
  </p>
  <div class="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-4 mt-16">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659301/Group_34207_q0qzuh.png" alt="">
    <img loading="lazy" class="w-16 h-16 md:w-24 md:h-20 relative " src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659317/Right_Arrow_y0xsjr.png" alt="">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659350/Group_34208_scs5qk.png" alt="">
  </div>
    </section>
    <!-- section 6 -->
     <section class=" container mt-44 mx-auto w-[70%]">
      <p class="text-white text-3xl dancing-script"> Closed Card Sort 1  </p>
    <p class="pt-6 text-lg text-white md:pt-16"> Added the "I don't Know" Category for testing, to allow participants room to not make forced choices if they did not understand a topic.</p>
  
      
     </section>
    <section class="w-full  flex flex-col justify-center items-center  mt-8 md:mt-24">
  
  <section

    class="w-full container flex background-lor flex-col items-center justify-center text-center   transition-transform duration-500 ease-in-out"
    
  >
    <div class="text-white text-center text-sm md:text-4xl">
      <p class="dancing-script mb-1 md:mb-6">Results</p>
      <ul class=" flex justify-between gap-10 dancing-script md:text-4xl text-white">
        <li>Participants       <span class=" montserrat font-bold">:9</span></li>
        <li>Cards              <span class=" montserrat font-bold">:28</span></li>
        <li>Tested Categories  <span class=" montserrat font-bold">:8</span></li>
      </ul>
    </div>
  </section>

</section>
    <!-- section 7 -->
    <section class="mt-10 w-full md:mt-20 px-4 md:px-20 flex flex-col justify-center container mx-auto text-amber-50 text-lg md:text-2xl">
  <p class="font-semibold text-lg pt-6 text-white md:pt-16">Findings:</p>
  <ol class="list-disc ml-5 md:ml-8">
    <li class="text-lg pt-6 md:pt-16">
      Participants <span class="text-amber-100">confused “Foundation L'Oréal” with foundation, a makeup product.</span>
    </li>
    <li class="text-lg pt-6 ">
      The <span class="text-amber-100">difference between “Safety” and “Responsibility”</span> was <span class="text-amber-100">not clear</span>, so participants placed similar cards into these categories.
    </li>
  </ol>
  <p class="text-lg pt-6 ">For example, “Fighting Climate Change” was put into both, when it was intended to be an environmental “Responsibility.”</p>
  <img  loading="lazy" class="pt-10 md:pt-20 w-full md:w-full" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659512/screen9_rwbqzq.png" alt="Result Matrix">
  <p class="dancing-script text-center text-lg pt-6 ">Result Matrix for Card Sort 1</p>
    </section>
   
    <!-- section 8 -->
    <section class="mt-14 flex flex-col justify-center md:mt-44 px-4 md:px-20 container mx-auto text-amber-50 text-lg md:text-xl">
  <section class="flex flex-col mb-10 text-amber-50">
    <p class="text-white text-2xl md:text-3xl font-semibold pt-6">Changes Implemented for Card Sort 2:</p>
    <article class="class=text-lg pt-6">
      <p class="text-lg pt-6 ">
        <span class="text-amber-100">Renamed categories</span> and cards for better clarification.
      </p>
      <ol class="list-decimal ml-5 md:ml-8">
        <li class="text-lg pt-6 ">
          Change <span class="text-amber-100 ">"Responsibility" to "Social Responsibility"</span> to evoke thoughts of responsibilities companies have to society, such as running initiatives for the environment.
        </li>
        <li class="text-lg pt-6 ">
          Tried to test a different title for "Foundation L'Oréal" for better context.
        </li>
      </ol>
      <p class="text-lg pt-6">Reintegrated more cards from the initial deck of 62 for testing to better flesh out the 28 cards that consisted of mostly general information.</p>
      <p class="pt-6"><span class="text-lg pt-24 text-amber-100">Increased the number of cards from 28 to 41</span></p>
    </article>
  </section>
  <img loading="lazy" class="w-full md:w-auto mt-8" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659577/Group_34209_itdbhv.png" alt="">
    </section>
    <!-- section 9 -->
     <section class="md:mt-44  px-20 container mx-auto">
      <p class="text-white text-3xl dancing-script">Hybrid Card Sort 2</p>
     </section>
    <section class="w-full flex flex-col justify-center items-center  mt-10 md:mt-20">
  <section
    class="w-full container flex background-lor flex-col items-center justify-center text-center   transition-transform duration-500 ease-in-out"
  >
   <div class="text-white text-center text-sm md:text-4xl">
      <p class="dancing-script mb-1 md:mb-6">Results</p>
      <ul class=" flex justify-between gap-10 dancing-script md:text-4xl text-white">
        <li>Participants       <span class=" montserrat font-bold">:11</span></li>
        <li>Cards              <span class=" montserrat font-bold">:41</span></li>
        <li>Tested Categories  <span class=" montserrat font-bold">:8</span></li>
      </ul>
    </div>
  </section>
</section>
    <!-- section 10 -->
    <section>
  <section class="flexmobile2 flex flex-col justify-center mx-auto text-amber-50 mt-10 md:mt-20 container  px-20">
    <section class="pt-0 text-xl font-medium text-amber-50 max-md:max-w-full">
      <p class="font-semibold text-lg pt-6 text-white ">Findings:</p>
      <ol class="list-decimal">
        <li class="text-lg pt-6 md:pt-16">
          One participant created a category called 
          <span class="text-amber-100">"Business and Finance"</span>, though most of their cards were placed into 
          <span class="text-amber-100">"About"</span> by all other participants.
        </li>
        <li class="text-lg pt-6 ">
          Specifically named cards, like <span class="text-amber-100">"Modiface"</span> from the Pilot Card Sort, ended up in 
          <span class="text-amber-100">"I don't know"</span> as participants didn't understand the context.
        </li>
        <li class="text-lg pt-6">
          <span class="text-amber-100">"Managing Water Sustainably"</span> was often placed under 
          <span class="text-amber-100">"Social Responsibility"</span>. This helped clarify content but also showed a need to prevent clutter in navigation. Participants still sorted similar cards between 
          <span class="text-amber-100">"Social Responsibility"</span> and 
          <span class="text-amber-100">"Safety"</span>.
        </li>
        <li class="text-lg pt-6 ">
          <span class="text-amber-100">"Foundation L'Oréal"</span> remained the same, but it would be better understood in the context of 
          <span class="text-amber-100">"Social Responsibility"</span>.
        </li>
      </ol>
    </section>
    <img loading="lazy" class="pt-20 md:max-w-full max-w-80" src="../assets/screen99.png" alt="Result Matrix">
    <p class="dancing-script text-center text-lg pt-6 ">Result Matrix for Card Sort 2</p>
  </section>
    </section>
    <!--  section 11 -->
    <section class="flexmobile2 text-xl flex flex-col justify-center container mx-auto mt-28  md:px-20 text-amber-50">
  <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">Site Map</p>
  <p class="text-lg pt-6 md:pt-16">The current L'Oréal Groupe website has 4 layers of menu items.</p>
  <p class="text-amber-100 text-lg pt-4 md:pt-8">The layers of the menu items were reduced from 4 to 3.</p>
  <img loading="lazy" class=" max-w-80 md:max-w-full" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726659627/nice-01_1_bj83iv.png" alt="Site Map Illustration">
    </section>
    <!-- section 12 -->
    </template>
    
  <script>
  export default {
    name: 'LorealProjectTwo',
    data() {
      return {
        inView: false, // Track if section 3 is in view
        isVisible: true // Control visibility of the section
      };
    },
    mounted() {
      // Initialize IntersectionObserver
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.inView = true; // Section is in view
          } else {
            this.inView = false; // Section is not in view
          }
        });
      });
  
      // Observe the section 3 element
      observer.observe(this.$refs.popupSection);
    }
  };
  </script>
  
  <style scoped>
  .background-lor{
    background-image: url("../assets/Group 34205.png");
    background-size:cover;
    width:1318px;
    height: 300px;
      
  }
 
  @media (max-width:740px) {
    .background-lor{
    background-image: url("../assets/Group 34205.png");
    background-size:cover;
    width:100%;
    height: 80px;
   
      
  }
  }
  .opacity-0 {
    opacity: 0;
  }
  .scale-0 {
    transform: scale(0);
  }
  .opacity-100 {
    opacity: 1;
  }
  .scale-100 {
    transform: scale(1);
  }
  </style>
  